import { useBCMSContext } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import ViewStatementPage from "components/pages/ViewStatementPage";
import { useEffect } from "react";

export default function CapturreMabiEStatementsEnrollScreen(props) {
    const context = useBCMSContext();
    const branding = context.state ?? {};

    useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    });

    return <ViewStatementPage />
}